import { forwardRef } from "react";
import { classNames } from "../../utils/classNames";

export const BreadcrumbPage = forwardRef<
  HTMLSpanElement,
  React.ComponentPropsWithoutRef<"span">
>(function BreadcrumbPage({ className, ...props }, ref) {
  return (
    <span
      ref={ref}
      role="link"
      tabIndex={0}
      aria-disabled="true"
      aria-current="page"
      className={classNames("font-semibold text-2xl/8 text-primary", className)}
      {...props}
    />
  );
});
BreadcrumbPage.displayName = "BreadcrumbPage";
